/**
 * ScreenEffects - Visual effects overlay (vignette, film grain, etc.)
 */

import React from 'react';
import { useSettingsStore } from '../../store/settingsStore';
import { useStoryStore } from '../../store/storyStore';
import WeatherEffect, { WeatherType } from './WeatherEffect';

const ScreenEffects: React.FC = () => {
  const { screenEffects } = useSettingsStore();
  const gameState = useStoryStore((state) => state.gameState);

  // Determine weather from game state (default to 'none' if not set)
  const weatherType = (gameState['weather'] as WeatherType) || 'none';

  if (!screenEffects) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-20">
      {/* Dynamic Weather Layer */}
      <WeatherEffect type={weatherType} />

      {/* Vignette Effect */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(circle at center, transparent 0%, transparent 50%, rgba(0,0,0,0.4) 100%)',
        }}
      />

      {/* Film Grain Effect */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat',
        }}
      />

      {/* Subtle Scanlines */}
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.1) 2px, rgba(0,0,0,0.1) 4px)',
        }}
      />
    </div>
  );
};

export default ScreenEffects;
